'use client';

import React from 'react';
import { Link } from 'react-router-dom';
import AppIcon from '@/core/presentation/components/ui/AppIcon';
import { Button } from '@/core/presentation/components/ui/Button';
import AppLogo from '@/core/presentation/components/ui/AppLogo';
import { LogoLink } from '@/features/app/presentation/components/LogoLink';

export interface AdminHeaderProps {
  /** Nome ou email do admin logado (somente exibição) */
  adminDisplayName?: string;
  onLogout?: () => void | Promise<void>;
  isLoggingOut?: boolean;
  onMenuClick?: () => void;
}

export const AdminHeader: React.FC<AdminHeaderProps> = ({
  adminDisplayName = 'Admin',
  onLogout,
  isLoggingOut = false,
  onMenuClick,
}) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-navy-dark border-b border-white/10 overflow-visible pt-[env(safe-area-inset-top,0px)]">
      <div className="h-14 flex items-center justify-between px-3 sm:px-4">
        <div className="flex items-center gap-2 min-w-0 overflow-visible">
          <button
            type="button"
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-lg text-white/90 hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan focus-visible:ring-offset-2 focus-visible:ring-offset-navy-dark shrink-0"
            aria-label="Abrir menu"
          >
            <AppIcon name="Bars3Icon" size={24} />
          </button>
          <LogoLink>
            <AppLogo src="/assets/images/retornaArLogo.png" size={140} />
          </LogoLink>
        </div>

        <div className="flex items-center gap-2 sm:gap-4 shrink-0">
          <span
            className="text-white/80 text-sm truncate max-w-[100px] sm:max-w-[200px]"
            title={adminDisplayName}
          >
            {adminDisplayName}
          </span>
          {onLogout && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={onLogout}
              disabled={isLoggingOut}
              loading={isLoggingOut}
              loadingLabel="Saindo"
              className="gap-1.5"
              aria-label="Sair"
            >
              <AppIcon name="ArrowRightOnRectangleIcon" size={18} />
              <span>Sair</span>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
